<div class="top-panel__menu">
  <div
    *ngIf="showBrowseSidebarOpenIcon()"
    (mousedown)="onBrowseSidebarOpenIconClick()"
    class="top-panel__browse-sidebar-open-icon"
  >
    <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="11.253" y1="9.67191" x2="1.35347" y2="19.5714" stroke="white" />
      <line x1="11.2461" y1="10.3536" x2="1.34656" y2="0.454058" stroke="white" />
    </svg>
  </div>

  <svg
    *ngIf="showBrowseSidebarOpenIcon()"
    class="top-panel__separator-icon"
    width="1"
    height="40"
    viewBox="0 0 1 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line x1="0.5" y1="2.18557e-08" x2="0.499998" y2="40" stroke="white" />
  </svg>

  <div class="top-panel__logo">
    <img class="top-panel__logo-image" src="assets/images/pitchbook-logo-white.png" alt="" />
    <span class="top-panel__logo-sub-title">Data Exchange Platform</span>
  </div>
</div>

<div class="top-panel__user-corner">
  <div #userCornerLink class="top-panel__user-corner-link" (click)="onUsernameLinkLinkClick()">
    <span class="top-panel__username">{{ username }}</span>

    <i class="fa fa-user-circle-o top-panel__user-icon" aria-hidden="true"></i>
    <i
      class="fa fa-angle-down"
      [ngClass]="{
        'fa-angle-down': userCornerPopupOpen,
        'fa-angle-up': !userCornerPopupOpen
      }"
      aria-hidden="true"
    >
    </i>
  </div>

  <app-user-corner-popup
    #userCornerPopup
    *ngIf="userCornerPopupOpen"
    (logout)="onUserCornerLogout()"
    (userSettings)="onUserCornerSettings()"
  >
  </app-user-corner-popup>
</div>
